// extracted by mini-css-extract-plugin
module.exports = {"info":"Input_info__3Nl9E","clear":"Input_clear__3twD7","stripe":"Input_stripe__1IItg","input":"Input_input__36_MF","value":"Input_value__20V4X","slider":"Input_slider__QQFxH"};